var _ = require('optimizely-client-fn');
var hashing = require('optimizely-hashing');
var JSONEnv = require('core/lib/json');
var createError = require('core/utils/custom_error').create;
var ODPError = createError('ODPError');

exports.getHashForOdpSegments = function(segments: string[]): string {
    if (!_.isArray(segments)) {
      throw new ODPError('Segments must be an array');
    }
    segments = _.sortBy(segments);
    return hashing.hashToHex(JSONEnv.stringify({segments: segments}), hashing.Seed.BEHAVIOR_EVENT);
};

export interface Segment {
    audiences: string[],
    custom: string[],
}

export interface OdpSegmentCache {
    segment: Segment,
    segmentHash: string,
    timestamp: number,
}
